import Button from 'components/Button';
import Error from 'components/form/Error';
import Input from 'components/form/Inputs/Input';
import ArrowRightIcon from 'components/icons/ArrowRight';
import { MentorshipStatusValues } from 'enums/MentorshipStatus';
import { FC, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { ButtonsContainer, InputContainer } from '.';
import { MentoringContext } from '..';
import ChangeReferee from './ChangeReferee';

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 1rem;
  }
  margin-bottom: 1rem;
`;

const MentorLateFirstInterview: FC = () => {
  const { mentorship } = useContext(MentoringContext);
  const [interruptLoading, setInterruptLoading] = useState(false);
  const [finishLoading, setFinishLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);

  const handleInterrupt = () => {
    setInterruptLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'INTERRUPTED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setError(false);
        setInterruptLoading(false);
      });
  };

  const handleFinish = () => {
    setFinishLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'FINISHED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setError(false);
        setFinishLoading(false);
      });
  };

  return (
    <div>
      <InputContainer>
        <p>Mentor actuel</p>
        <Link
          to={`/admin/mentoring/mentors/${mentorship?.mentor?.id}/mentoring/ongoing/`}
        >
          <Input
            style={{ cursor: 'pointer' }}
            value={
              mentorship?.mentor?.firstName + ' ' + mentorship?.mentor?.lastName
            }
            icon={<ArrowRightIcon />}
            iconSide="right"
            readOnly
          />
        </Link>
        <ChangeReferee mentorship={mentorship} />
      </InputContainer>
      <ActionContainer>
        <p>
          Le mentor ne s'est pas présenté lors du premier entretien. Quelle
          action souhaitez-vous effectuer ?
        </p>
        <ButtonsContainer>
          <Button
            color="primary"
            onClick={handleInterrupt}
            loading={interruptLoading}
          >
            Interrompre le mentorat
          </Button>
          <Button
            color="primary"
            onClick={handleFinish}
            loading={finishLoading}
          >
            Terminer le mentorat
          </Button>
        </ButtonsContainer>
        {error && <Error>Une erreur est survenue.</Error>}
      </ActionContainer>
    </div>
  );
};

export default MentorLateFirstInterview;
